import styled from 'styled-components';
import { fontSizes } from 'app/styles/variables';
import { Typography } from 'app/shared/components/Typography/Typography';

interface CollapsibleContainerStProps {
  isOpen?: boolean;
  isClosing?: boolean;
  noTopBorder?: boolean;
  noBottomBorder?: boolean;
}

export const CollapsibleContainerSt = styled.div<CollapsibleContainerStProps>`
  border-top: ${({ theme, noTopBorder }) =>
    noTopBorder ? 'none' : `1px solid ${theme.colors.neutral100}`};
  border-bottom: ${({ isOpen, isClosing, theme, noBottomBorder }) =>
    !isOpen && !isClosing && !noBottomBorder
      ? `1px solid ${theme.colors.neutral100}`
      : 'none'};

  ${({ isOpen }) =>
    isOpen
      ? ''
      : `& + & {
    border-top: none;
  }`}
`;

export const CollapsibleHeadingSt = styled(Typography).attrs({
  variant: 'body1',
  Component: 'div',
})`
  text-align: start;
`;

interface CollapsibleButtonStProps {
  isLarge?: boolean;
}

export const CollapsibleButtonSt = styled.button<CollapsibleButtonStProps>`
  width: 100%;

  ${({ isLarge }) => (isLarge ? 'padding: 1rem 0;' : 'padding: 0.5rem 0;')}

  border: none;
  line-height: 2rem;
  background: transparent;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.neutral800};
`;

interface CollapsibleButtonImageStProps {
  isOpen?: boolean;
}

export const CollapsibleButtonImageSt = styled.div<CollapsibleButtonImageStProps>`
  display: flex;
  width: 20px;
  height: 100%;
  align-items: center;

  > svg {
    transition: transform 200ms ease-in-out;
    transform: scaleY(${({ isOpen }) => (isOpen ? '-1' : '1')});
  }
`;

interface CollapsibleContentStProps {
  isOpen?: boolean;
  isOpening?: boolean;
  isClosing?: boolean;
}

export const CollapsibleWrapperSt = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 32px;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const CollapsibleContentSt = styled.div<CollapsibleContentStProps>`
  max-height: 0;
  margin: 0.5rem -0.5rem;
  padding: 0 0.5rem;
  transition: max-height 200ms ease-out;
  overflow-y: hidden;
  ${({ isOpen, isClosing }) => (!isOpen && !isClosing ? 'margin: 0;' : '')}
  ${({ isOpening }) => (isOpening ? `max-height: 100vh;` : '')}
  ${({ isOpen, isOpening }) =>
    isOpen && !isOpening
      ? `max-height: initial;
    overflow: unset;`
      : ''}
`;

export const CollapsibleSelectedOptionsSt = styled.div<{ isOpen: boolean }>`
  text-align: left;
  color: ${({ theme }) => theme.colors.neutral500};
  ${({ isOpen }) =>
    isOpen
      ? 'max-height: 0;'
      : `max-height: initial;
  overflow: unset;`}
  transition: max-height 200ms ease-out;
  overflow-y: hidden;
  font-size: ${fontSizes.p3};
`;
